import React, { useState } from "react";
import { downloadEvidenceMapPDF } from "../../pdf/DownloadEvidenceMapPDF";
import { captureTreeMapAsPDF } from "../../pdf/GenerateTreeMapPDF";
import DownloadStatusModal from "../DownloadStatusModal/DownloadStatusModal";

export default function DownloadMaps({ defaultType, evidenceMapContainer })
{
  const [downloadStatus, setDownloadStatus] = useState(null);

  const handleDownloadClick = () =>
  {
    console.log("status before click: ",downloadStatus)
    if (defaultType === "Evidence Map")
    {
      downloadEvidenceMapPDF()
      .then(status => {
        setDownloadStatus({ status: "success", message: status })
        // console.log("download status success: ",status)
      })
      .catch(error => {
        setDownloadStatus({ status: "error", message: error })
        // console.log("download status error: ",error)
      });
    } else
    {
      captureTreeMapAsPDF()
      .then(status => {
        setDownloadStatus({ status: "success", message: status })
        // console.log("download status success: ",status)
      })
      .catch(error => {
        setDownloadStatus({ status: "error", message: error })
        // console.log("download status error: ",error)
      });
    }
  };

  const handleCloseModal = () => {
    setDownloadStatus(null);
    console.log("status when closing: ",downloadStatus)
  }

  return (
    <>
    <button className="orange-button-download" onClick={handleDownloadClick}>
      Download
    </button>
    {downloadStatus && (
      <DownloadStatusModal onClose={handleCloseModal} downloadStatus={downloadStatus}/>
    )}
    </>
  );
}

